import { connect, Dispatch } from 'react-redux';
import * as actions from '../actions';
import { LoginWithToken } from '../components/Login/LoginWithToken';

export const mapStateToProps = ({}) => {
  return {
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<actions.AuthAction>)  => {
  return {
    onLoginClick: (token: string, expertId: string) => 
    dispatch(actions.loginWithToken(token, expertId)),
  };
};

export const mergeProps = (stateProps: Object, dispatchProps: Object, ownProps: Object) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps);
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(LoginWithToken);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/LoginWithToken.ts